import React, { useEffect, useState, Fragment  } from 'react'
import { Row, Col, Container, Modal, Card, Button, Form, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { formatoMonto } from '../../../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { serviceGetProvisionesImplicado } from '../../../../api/api-visar-provision'
import { FaUserTie } from 'react-icons/fa'

const GrillaPrevisionesImplicados = ({action, showModalProvisionesImplicado, setShowModalProvisionesImplicado}) => {
    const { codMonedaLocal } = Auth.currentUser()
    const [data, setData] = useState([])
  
    const visar_provision = useSelector((state) => state.visarProvisionReducer);
    const { cfg_form44, listaProvisionesImplicados, comboMonedas } = visar_provision;

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    const [stateMoneda, setStateMoneda] = useState('')
    const [loading, setLoading] = useState(false)

    const [tituloModal, setTituloModal] = useState('')
    const [comentario, setComentario] = useState('Sin comentarios.')
    const [comentarioVisado, setComentarioVisado] = useState('Sin comentarios.')
    const [showModal, setShowModal] = useState(false)

    const [showObsModal, setShowObsModal] = useState(false)
    const [obsModalData, setObsModalData] = useState({ titulo: '', content: '' })

    const abrirObsCobertura = (titulo, content) => {
        setObsModalData({ titulo, content })
        setShowObsModal(true)
    }

  useEffect(() => {
    setData([])
    if (
      listaProvisionesImplicados &&
      listaProvisionesImplicados.listaProvisionesImplicados &&
      listaProvisionesImplicados.listaProvisionesImplicados.length > 0
    ) {
      setData(listaProvisionesImplicados.listaProvisionesImplicados)
    }
  }, [listaProvisionesImplicados])

  useEffect(() => {
    if (comboMonedas) setStateMoneda(codMonedaLocal)
  }, [comboMonedas])

  const loadMovimientosImplicado = async (moneda) => {
    setStateMoneda(moneda)
    setLoading(true)
    let query = Buffer.from(
      JSON.stringify({
        idCaso: llaves && llaves['idCaso'],
        tipoMovimiento: action === 'button' ? 261002 : 261003,
        codMoneda: moneda
      })
    ).toString('base64')

    const response = await serviceGetProvisionesImplicado(query)
    setData(response)
    setLoading(false)
  }

  // 🧮 Cálculos dinámicos
  const coberturas = Array.from(
    new Map(
      data.flatMap((d) => d.coberturas?.map((c) => [c.codigo, c])) ?? []
    ).values()
  )

  const totalPorImplicado = (imp) =>
    imp.coberturas?.reduce((sum, c) => sum + (c.monto || 0), 0) || 0

  const totalPorCobertura = (codigo) =>
    data.reduce(
      (sum, imp) =>
        sum +
        (imp.coberturas?.find((c) => c.codigo === codigo)?.monto || 0),
      0
    )

  const totalGeneral = data.reduce(
    (sum, imp) => sum + totalPorImplicado(imp),
    0
  )

  const ultimaFechaImplicado = (imp) => {
    const fechas = imp.coberturas
      ?.map((c) => c.ultFechaRegistro)
      .filter((f) => !!f)
    if (!fechas || fechas.length === 0) return '-'
    return fechas.sort(
      (a, b) =>
        new Date(a.split('-').reverse().join('-')) -
        new Date(b.split('-').reverse().join('-'))
    )[fechas.length - 1]
  }

  const abrirObservaciones = (imp) => {
    setComentario(imp?.comentario || '<Sin Observaciones>')
    setComentarioVisado(imp?.comentaVisado || '<Sin Observaciones>')
    setTituloModal(action === 'button' ? 'Provisiones' : 'Valorización PEC')
    setShowModal(true)
  }

  return (
    <>
      <LoadingComponent show={loading} />
      <Modal
        show={showModalProvisionesImplicado}
        onHide={setShowModalProvisionesImplicado}
        size="xl"
      >
        <Container>
          {/* 🔹 Header */}
          <Row
            style={{
              backgroundColor: '#4F517A',
              color: 'white',
              borderRadius: '4px',
              padding: '5px 10px',
              margin: '0 -12px'
            }}
          >
            <Col md="12">
              <Form.Label
                className="mb-0 mt-0"
                style={{ color: 'white', width: '100%' }}
              >
                {cfg_form44?.['modalprovisiones-title'] ||
                  'PRETENSIONES IMPLICADOS'}
              </Form.Label>
            </Col>
          </Row>

          {/* 🔹 Tabla dinámica */}
          <div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{ minWidth: '200px' }}>Cobertura</th>
                  {data.map((imp) => (
                    <th key={imp.rut}>
                      {imp.nombre}
                      <br />
                    </th>
                  ))}
                  <th>Total Cobertura</th>
                </tr>
              </thead>
              <tbody>
                {coberturas.map((cob) => (
                  <tr key={cob.codigo}>
                    <td style={{ textAlign: 'left', fontWeight: 'normal'}}>
                      {cob.nombre}
                    </td>
                    {data.map((imp) => {
                      const found = imp.coberturas?.find(
                        (x) => x.codigo === cob.codigo
                      )
                      return (
                        <td
                          key={imp.rut + cob.codigo}
                          style={{ textAlign: 'right' }}
                        >
                          {formatoMonto(found?.monto || 0, false)}
                          {' '}
                          <FaUserTie
                            size={12}
                            color={found?.obsResponsable ? '#28a745' : '#ccc'}
                            title={found?.obsResponsable ? 'Obs. Abogado' : 'Sin observación del abogado'}
                            style={{ cursor: found?.obsResponsable ? 'pointer' : 'default', marginLeft: '3px', verticalAlign: 'middle' }}
                            onClick={found?.obsResponsable ? () => abrirObsCobertura('Obs. Abogado — ' + cob.nombre, found.obsResponsable) : undefined}
                          />
                        </td>
                      )
                    })}
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {formatoMonto(totalPorCobertura(cob.codigo), false)}
                    </td>
                  </tr>
                ))}

                {/* 🔸 Totales */}
                <tr>
                  <td style={{ fontWeight: 'bold' }}>TOTAL IMPLICADO</td>
                  {data.map((imp) => (
                    <td
                      key={'total-' + imp.rut}
                      style={{ textAlign: 'right', fontWeight: 'bold' }}
                    >
                      {formatoMonto(totalPorImplicado(imp), false)}
                    </td>
                  ))}
                  <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    {formatoMonto(totalGeneral, false)}
                  </td>
                </tr>
                {/* 🔸 Último registro */}
                <tr className="table-light">
                  <td style={{ fontWeight: 'bold' }}>Último Registro</td>
                  {data.map((imp) => (
                    <td
                      key={'fecha-' + imp.rut}
                      style={{ textAlign: 'right', cursor: 'pointer', color: '#007bff' }}
                      onClick={() => abrirObservaciones(imp)}
                    >
                      {ultimaFechaImplicado(imp)}
                    </td>
                  ))}
                  <td>-</td>
                </tr>
              </tbody>
            </Table>
          </div>

          {/* 🔹 Botón cerrar */}
          <Row>
            <Col className="d-flex align-items-end justify-content-end m-2 p-0">
              <Button
                className="m-2 w-auto"
                variant="outline-info"
                onClick={() => setShowModalProvisionesImplicado(false)}
              >
                {cfg_form44?.cfg_form39?.['modalprovisiones-btn-volver'] || 'Volver'}
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal>

      <Modal show={showObsModal} onHide={() => setShowObsModal(false)} size='md' centered>
        <Modal.Header style={{ backgroundColor: '#4F517A', color: 'white' }} closeButton>
          <Modal.Title style={{ fontSize: '14px' }}>{obsModalData.titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ whiteSpace: 'pre-wrap', fontSize: '14px', marginBottom: 0 }}>{obsModalData.content}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={() => setShowObsModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* 🔸 Modal de observaciones */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="md">
        <Card>
          <Card.Header
            className="mt-0 mb-0"
            as="h6"
            style={{ backgroundColor: '#e8761a', color: 'white' }}
          >
            Observaciones - {tituloModal}
          </Card.Header>
          <Card.Body>
            <h5 className="card-title">Responsable Gestión:</h5>
            {comentario}
            <br />
            <br />
            <h5 className="card-title">Analista Compañía:</h5>
            {comentarioVisado}
          </Card.Body>
          <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              className="m-2 w-auto"
              variant="outline-info"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
          </Card.Footer>
        </Card>
      </Modal>
    </>
  )
}

export default GrillaPrevisionesImplicados
